import React from 'react';
import DealerAd from '../..';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import cn from 'classnames';

import s from './Banner.scss';

export interface Props {
  realEstateId: string;
  width: string;
  height: string;
  className?: string;
}

const BannerAdUnit: React.FC<Props> = ({
  realEstateId,
  width,
  height,
  className,
}) => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="BannerAdUnit">
      <div className={cn(s['wrapper'], className)} style={{ width, height }}>
        <DealerAd
          realEstateId={realEstateId}
          extraParams={
            process.env.NODE_ENV === 'development'
              ? {
                  forcefixture: `complexbanner${width}-${height}`,
                }
              : {}
          }
        />
      </div>
    </ErrorBoundary>
  );
};
BannerAdUnit.displayName = 'BannerAdUnit';

export default BannerAdUnit;
